import(/* webpackMode: "eager", webpackExports: ["default"] */ "/snv/components/advertisement/NewsBottomAd.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/snv/components/layout/GoTop.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/snv/components/layout/TagComponent.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/snv/components/news/NewsCommentWrapper.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/snv/components/news/NewsContent.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/snv/components/news/NewsInteractionWrapper.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/snv/components/news/NewsParagraph.js");
;
import(/* webpackMode: "eager" */ "/snv/components/news/NewsProgressBar.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/snv/components/news/NewsRelatedWrapper.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/snv/components/news/NewsSocialCount.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/snv/components/news/TopNewsWrapper.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/snv/components/TranslationsProvider.js");
;
import(/* webpackMode: "eager" */ "/snv/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/snv/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/snv/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/snv/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/snv/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
